import React from 'react';
import { addDays, addMonths, isAfter } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';

import DatePicker from '../../../Common/DatePicker';

export const ChangeAddressDate: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { changeAddressDate } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepChangeAddressDate">
      <h3>{t('manageContracts:manageContracts.ChangeAddressDateTitle')}*</h3>

      {changeAddressDate && (
        <DatePicker
          type="single"
          day={{ date: changeAddressDate, setDate: () => dispatch(['newAddressDate', changeAddressDate]) }}
          limits={{ minDate: addDays(new Date(), 3), maxDate: addMonths(new Date(), 6) }}
          onDateChange={(changeAddressDate): void => {
            dispatch(['newAddressDate', changeAddressDate]);

            if (changeAddressDate && isAfter(changeAddressDate, addMonths(new Date(), 6))) {
              dispatch(['changeStart', addMonths(new Date(), 6)]);
            }
          }}
        />
      )}
    </section>
  );
};

export default ChangeAddressDate;
